export default {
  type: "unit-of-measures",
  name: null,
  relationshipNames: ["organization"],
  organization: {
    type: "organizations",
    id: null,
  },
};
